module.exports = __webpack_public_path__ + "media/ppc/hero-hispanic-female-7ce84eaf.jpg";